import { cn } from "@racoon/ui";
import { Namespace, useTypedT } from "@racoon/i18n";

export interface AddStopChoiceContentProps {
  /** Record work that does not exist in the system yet. */
  onCreate: () => void;
  /** Pick jobs the system already has and that are on no route. */
  onPickExisting: () => void;
}

/**
 * A stop is either work being recorded for the first time or a job the system
 * already has; the two are picked in different modals, so ask first.
 */
export const AddStopChoiceContent = ({ onCreate, onPickExisting }: AddStopChoiceContentProps) => {
  const t = useTypedT(Namespace.Routes);

  const options = [
    {
      key: "create",
      title: t("addStopCreateTitle"),
      hint: t("addStopCreateHint"),
      select: onCreate,
    },
    {
      key: "existing",
      title: t("addStopExistingTitle"),
      hint: t("addStopExistingHint"),
      select: onPickExisting,
    },
  ];

  return (
    <div className="flex flex-col">
      {options.map((option, index) => (
        <div
          key={option.key}
          className={cn(
            "flex flex-col items-start gap-2 p-6",
            index > 0 && "border-t border-border-primary",
          )}
        >
          <button
            type="button"
            onClick={option.select}
            className="rounded-lg bg-blue-100 px-3 py-2 text-sm font-medium leading-4 tracking-[-0.2px] text-blue-600 transition-colors"
          >
            {option.title}
          </button>
          <p className="text-sm leading-5 tracking-[-0.01em] text-text-body">{option.hint}</p>
        </div>
      ))}
    </div>
  );
};
